import React from 'react';
import cc from 'classnames';

import styles from './FieldsLeveler.module.css';

interface IFieldsLevelerProps {
  label: React.ReactNode,
  dividerBottom?: boolean,
  children: React.ReactNode,
  subTitle?: React.ReactNode,
}

const FieldsLeveler = ({ label, dividerBottom, children, subTitle }: IFieldsLevelerProps) => (
  <div className={cc(styles.grid, { [styles.dividerBottom]: dividerBottom })}>
    <div className={styles.labelContainer}>
      <div className={styles.label}>{label}</div>
      <div className={styles.subtitle}>{subTitle}</div>
    </div>
    <div className={styles.field}>{children}</div>
  </div>
);

export default FieldsLeveler;
